import { z } from 'src/lib'
import { ComentarioPostFields } from '../types'
import { BaseResponse, BaseResponseWithData } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { getEndpointBySistema } from './httpSistema'

const schema = z.object({
    [ComentarioPostFields.CodComentarioTipo]: z.number(),
    [ComentarioPostFields.Comentario]: z.string()
})

export type ComentarioNuevoDTO = z.infer<typeof schema>

export const postComentario = (
    codSistema: number,
    idOperacion: number,
    comentario: ComentarioNuevoDTO
): Promise<BaseResponse> => {
    const endpoint = 'comentarios'
    const getEndpointRelacionar = (idComentario: number) =>
        `${getEndpointBySistema(codSistema)}/${idOperacion}/comentarios/${idComentario}`

    const parsed = schema.safeParse(comentario)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(endpoint, parsed.data)
        .then(res => {
            return HttpAxiosRequest.post(getEndpointRelacionar(res.data), {})
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
